import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'skeleton-element',
  shadow: true,
  styleUrl: 'skeleton-element.scss'
})
export class SkeletonElement {
  @Prop() class: string = '';

  render() {
    return <div class={`bg-gray-200 animate-pulse rounded-[inherit] h-full w-full`} />;
  }
}
